export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";